module.exports = __webpack_public_path__ + "files/a0aeb255d605d4f3e129bc7c3ecff152.svg";